// Copyright 2019 Drivetrain Hub LLC
// Helper functions for Vuex.
// Avoids actions boilerplate in Vuex getters, mutations, and actions.
// https://github.com/vuejs/vuex/issues/684

import {isObj} from "../assets/js/utils";

// region Getters

export function getObjectById(arr, Id) {
  return arr.find(item => item.Id === Id)
}

export function getIndexById(arr, Id) {
  // https://gist.github.com/scottopolis/6e35cf0d53bae81e6161662e6374da04
  return arr.map(function(item) { return item.Id; }).indexOf(Id);
}

export function getIndexByPropValue(arr, prop, val) {
  // https://gist.github.com/scottopolis/6e35cf0d53bae81e6161662e6374da04
  return arr.map(function(item) { return item[prop]; }).indexOf(val);
}

// endregion


// region Updaters

export function replaceObjectById(arr, obj) {
  const i = getIndexById(arr, obj.Id);
  arr[i] = obj;
}

export function updateObject(obj, payload) {
  // Recursively assign property values of payload to obj.
  // obj must contain the properties specified in payload.
  // https://stackoverflow.com/questions/7241878/for-in-loops-in-javascript-key-value-pairs
  // WARNING: The result of Object.assign(obj, payload) references the `obj` arg object.

  Object.keys(payload).forEach(key => {
    if (isObj(obj[key]) && isObj(payload[key])) {
      updateObject(obj[key], payload[key]);
    } else {
      obj[key] = payload[key]
    }
  });
}

export function updateObjectById(arr, obj) {
  // Update an object in an array.
  // Returns updated object (not array).

  let objToUpdate = getObjectById(arr, obj.Id);
  updateObject(objToUpdate, obj);

  return objToUpdate;
}

// endregion


// region Removers

export function removeValue(arr, val) {
  // NOTE: function operates on array instance, hence no return
  const removeIndex = arr.indexOf(val);
  if (removeIndex > -1) arr.splice(removeIndex, 1)
}

export function removeObjectById(arr, Id) {
  // NOTE: function operates on array instance, hence no return
  const removeIndex = getIndexById(arr, Id);
  if (removeIndex > -1) arr.splice(removeIndex, 1);

  // ALTERNATIVE APPROACH:
  // arr.filter(item => item.Id !== id);
}

export function removeObjectByPropValue(arr, prop, val) {
  // NOTE: function operates on array instance, hence no return
  const removeIndex = getIndexByPropValue(arr, prop, val);
  if (removeIndex > -1) arr.splice(removeIndex, 1);

  // ALTERNATIVE APPROACH:
  // arr.filter(item => item.Id !== id);
}

// endregion
